import React, { useEffect, useState } from 'react';
import { Activity, Zap, Clock } from 'lucide-react';
import styles from './PerformanceMonitor.module.css';

const PerformanceMonitor = () => {
  const [metrics, setMetrics] = useState({
    loadTime: 0,
    renderTime: 0,
    memoryUsage: 0,
    isVisible: false
  });

  useEffect(() => {
    // Measure page load time
    const loadTime = performance.now();
    
    // Measure memory usage (if available)
    const memoryUsage = performance.memory ? 
      Math.round(performance.memory.usedJSHeapSize / 1024 / 1024) : 0;

    // Measure render time
    const renderStart = performance.now();
    requestAnimationFrame(() => {
      const renderTime = performance.now() - renderStart;
      
      setMetrics({
        loadTime: Math.round(loadTime),
        renderTime: Math.round(renderTime),
        memoryUsage,
        isVisible: true
      });
    });

    // Hide after 3 seconds
    const timer = setTimeout(() => {
      setMetrics(prev => ({ ...prev, isVisible: false }));
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!metrics.isVisible) return null;

  return (
    <div className={styles.performanceMonitor}>
      <div className={styles.metric}>
        <Clock size={14} />
        <span>{metrics.loadTime}ms</span>
      </div>
      <div className={styles.metric}>
        <Zap size={14} />
        <span>{metrics.renderTime}ms</span>
      </div>
      {metrics.memoryUsage > 0 && (
        <div className={styles.metric}>
          <Activity size={14} />
          <span>{metrics.memoryUsage}MB</span>
        </div>
      )}
    </div>
  );
};

export default PerformanceMonitor;
